import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/geoSuburb/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/geoSuburb/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/geoSuburb/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/geoSuburb/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/geoSuburb/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/geoSuburb/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/geoSuburb/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/geoSuburb/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/geoSuburb/UPDATE_FAILURE'

// Initial State
const initialState = {
  loaded: false,
  loadedIds: [],
  loading: false,
  creating: false,
  updating: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadGeoSuburbs(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/geo_suburbs.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_SUBURB_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadGeoSuburb(geoSuburb, options){
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.geoSuburbs.loadedIds ? state.geoSuburbs.loadedIds.slice() : []
    if (!loadedIds.includes(geoSuburb.id)){
      loadedIds.push(geoSuburb.id)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`/admin/geo_suburbs/${geoSuburb.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_SUBURB)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createGeoSuburb(geoSuburb, options, successCallback, errorCallback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      geo_suburb: geoSuburb,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/geo_suburbs.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_SUBURB)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (successCallback) successCallback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        if (errorCallback) errorCallback(errors)
      })

    return promise
  }
}

export function updateGeoSuburb(geoSuburb, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      geo_suburb: geoSuburb,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/geo_suburbs/${geoSuburb.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.GEO_SUBURB)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return { ...state, creating: true }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return { ...state, updating: true }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
